var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('el-tab-pane',{attrs:{"label":"服务概况","name":"ref1"}},[_c('ServiceSummary')],1),_c('el-tab-pane',{attrs:{"label":"时长概况","name":"ref2"}},[_c('DurationSummary')],1),_c('el-tab-pane',{attrs:{"label":"变化趋势","name":"ref3"}},[_c('Trend')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }